import { render } from "./BottomFooter.vue?vue&type=template&id=ab3105d8&scoped=true"
import script from "./BottomFooter.vue?vue&type=script&lang=js"
export * from "./BottomFooter.vue?vue&type=script&lang=js"

import "./BottomFooter.vue?vue&type=style&index=0&id=ab3105d8&scoped=true&lang=css"

import exportComponent from "/codebuild/output/src718038542/src/nickyadvokaat-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ab3105d8"]])

export default __exports__